<template>
    <main-content>
        <shareholder-form v-if="data_is_ready" :records="records">
        </shareholder-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import shareholderForm from './components/shareholder-form';
import { walletShareHolderService } from '@/common/api.service';

export default {
    components: {
        mainContent,
        shareholderForm
    },
    data() {
        return {
            records: [],
            data_is_ready: false
        };
    },
    mounted() {
        walletShareHolderService
            .shareholderDetail(this.$route.params.hashid)
            .then((res) => {
                this.records = res.data.data.records;
                this.data_is_ready = true;
            });
    }
};
</script>
